import * as React from 'react'
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DateField,
  NumberField,
  ListProps,
  ShowButton,
  DeleteWithConfirmButton,
  Record,
  useNotify,
  useRefresh,
} from 'react-admin'
import CouponsListActions from './CouponsListActions'
import CouponsListFilters from './CouponsListFilters'
import CouponStatusChip from '../../../components/chips/CouponStatusChip'
import CouponTypeChip from '../../../components/chips/CouponTypeChip'
import CouponAppliesToChip from '../../../components/chips/CouponAppliesToChip'

const CouponsList = (props: ListProps) => {
  const notify = useNotify()
  const refresh = useRefresh()

  return (
    <List
      {...props}
      title="Cupons"
      actions={<CouponsListActions />}
      filters={<CouponsListFilters />}
      perPage={25}
      sort={{ field: 'createdAt', order: 'DESC' }}
      filterDefaultValues={{
        status: 'active',
      }}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="edit" size="medium">
        <TextField
          source="code"
          label="Código"
          sortable
          style={{ fontWeight: 600, fontSize: '0.9rem' }}
        />
        <FunctionField
          label="Status"
          render={(record?: Record) => (
            <CouponStatusChip
              status={
                (record?.status as
                  | 'active'
                  | 'inactive'
                  | 'expired'
                  | 'archived') || 'active'
              }
            />
          )}
        />
        <FunctionField
          label="Tipo/Valor"
          render={(record?: Record) => (
            <CouponTypeChip
              type={
                (record?.type as 'percentage' | 'fixed' | 'fixedPrice') ||
                'percentage'
              }
              value={(record?.value as number) || 0}
            />
          )}
        />
        <FunctionField
          label="Aplicação"
          render={(record?: Record) => (
            <CouponAppliesToChip
              appliesTo={
                (record?.appliesTo as
                  | 'all_products'
                  | 'categories'
                  | 'specific_products') || 'all_products'
              }
              eligibleItems={(record?.eligibleItems as string[]) || []}
            />
          )}
        />
        <DateField
          source="validFrom"
          label="Válido de"
          showTime={false}
          locales="pt-BR"
          sortable
        />
        <DateField
          source="validUntil"
          label="Válido até"
          showTime={false}
          locales="pt-BR"
          sortable
        />
        <NumberField source="usageLimit" label="Limite" sortable />
        <DateField
          source="createdAt"
          label="Criado em"
          showTime={false}
          locales="pt-BR"
          sortable
        />
        <FunctionField
          label="Ações"
          render={(record?: Record) => (
            <div
              style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}
            >
              <ShowButton label="" record={record} />
              {!!record && record.code && record.status != 'archived' && (
                <DeleteWithConfirmButton
                  onSuccess={() => {
                    notify('Cupom arquivado com sucesso')
                    refresh()
                  }}
                  label=""
                  record={{ ...record, id: record.code }}
                  mutationMode="pessimistic"
                  confirmTitle={`Arquivar cupom #${record.code}`}
                  confirmContent="Tem certeza que deseja arquivar esse cupom?"
                />
              )}
            </div>
          )}
        />
      </Datagrid>
    </List>
  )
}

export default CouponsList
